<template>
    <PlanbordGridRow>
        <PlanbordGridLeftDataColumns>
            <PlanbordGridCell info v-if="functionName">{{ functionName }}<i v-if="isReachable"> (bereikbaar)</i></PlanbordGridCell>
            <PlanbordGridCell info v-else><i>Paraatheid zonder functie-eis</i><i v-if="isReachable"> (bereikbaar)</i></PlanbordGridCell>
            <PlanbordFunctionCell />
            <PlanbordCommentCell />
            <PlanbordStampStartDateCell />
        </PlanbordGridLeftDataColumns>
        <WorkloadRequirementsCell v-for="(day, i) in allDays" :key="i" :requirements="requirements[day.formattedForComputers] ?? {}" :fulfillment="fulfillment[day.formattedForComputers] ?? {}" :date="day.date" :nextDate="allDays[i + 1]?.date" :precision="precision" />
    </PlanbordGridRow>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import WorkloadRequirementsCell from '@/components/Planbord/WorkloadRequirements/WorkloadRequirementsCell.vue';
    import PlanbordGridRow from '@/components/Planbord/PlanbordGridRow.vue';
    import {RosterDay} from '@/types/types';
    import {WorkloadRequirement} from '@cquential/api';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import PlanbordFunctionCell from '@/components/Planbord/PlanbordFunctionCell.vue';
    import PlanbordCommentCell from '@/components/Planbord/PlanbordCommentCell.vue';
    import PlanbordGridLeftDataColumns from '@/components/Planbord/PlanbordGridLeftDataColumns.vue';
    import PlanbordStampStartDateCell from '@/components/Planbord/PlanbordStampStartDateCell.vue';

    @Component({
        components: {
            WorkloadRequirementsCell,
            PlanbordGridRow,
            PlanbordGridCell,
            PlanbordFunctionCell,
            PlanbordCommentCell,
            PlanbordGridLeftDataColumns,
            PlanbordStampStartDateCell,
        },
    })
    export default class WorkloadRequirementsRow extends Vue {
        @Prop({required: true}) public requirements!: Record<string, Record<number, WorkloadRequirement>>;
        @Prop({required: true}) public fulfillment!: Record<string, Record<number, number>>;
        @Prop() public functionName?: string;
        @Prop({required: true}) public allDays!: RosterDay[];
        @Prop({type: Number, required: true}) public precision!: number;
        @Prop({type: Boolean}) public isReachable!: boolean;
    }
</script>

<style lang="scss" scoped>
    .name-column {
        padding: calc(var(--td-padding) + var(--deployment-holder-padding)) calc(var(--td-padding) + 0.2rem);
    }
</style>
